import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

function Clients() {
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', notes: '', formula_notes: '' });
  const [showHistory, setShowHistory] = useState(false);
  const [selectedClientHistory, setSelectedClientHistory] = useState(null);
  const [appointmentHistory, setAppointmentHistory] = useState([]);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    const response = await axios.get(`${API_URL}/clients`);
    setClients(response.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingClient) {
      await axios.put(`${API_URL}/clients/${editingClient.id}`, formData);
    } else {
      await axios.post(`${API_URL}/clients`, formData);
    }
    setShowModal(false);
    setEditingClient(null);
    setFormData({ name: '', email: '', phone: '', notes: '', formula_notes: '' });
    fetchClients();
  };

  const viewHistory = async (client) => {
    setSelectedClientHistory(client);
    const response = await axios.get(`${API_URL}/clients/${client.id}/history`);
    setAppointmentHistory(response.data);
    setShowHistory(true);
  };

  const deleteClient = async (id) => {
    if (window.confirm('Delete this client?')) {
      await axios.delete(`${API_URL}/clients/${id}`);
      fetchClients();
    }
  };

  return (
    <div className="clients">
      <div className="header">
        <h2>Clients</h2>
        <button onClick={() => setShowModal(true)}>Add Client</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Notes</th>
            <th>Formula Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {clients
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(client => (
              <tr key={client.id}>
                <td>{client.name}</td>
                <td>{client.email}</td>
                <td>{client.phone}</td>
                <td>{client.notes}</td>
                <td>{client.formula_notes}</td>
                <td className="actions">
                  <button onClick={() => viewHistory(client)} className="btn-small">History</button>
                  <button onClick={() => { setEditingClient(client); setFormData(client); setShowModal(true); }} className="btn-small">Edit</button>
                  <button onClick={() => deleteClient(client.id)} className="btn-small delete">Delete</button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>{editingClient ? 'Edit Client' : 'Add Client'}</h3>
            <form onSubmit={handleSubmit}>
              <input type="text" placeholder="Name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
              <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} />
              <input type="tel" placeholder="Phone" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} required />
              <textarea placeholder="General Notes" value={formData.notes || ''} onChange={(e) => setFormData({...formData, notes: e.target.value})} rows="3" />
              <textarea placeholder="Formula Notes" value={formData.formula_notes || ''} onChange={(e) => setFormData({...formData, formula_notes: e.target.value})} rows="3" />
              <div className="modal-actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => { setShowModal(false); setEditingClient(null); setFormData({ name: '', email: '', phone: '', notes: '', formula_notes: '' }); }}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showHistory && selectedClientHistory && (
        <div className="modal">
          <div className="modal-content" style={{ maxWidth: '800px' }}>
            <h3>Service History - {selectedClientHistory.name}</h3>
            <div style={{ marginBottom: '20px' }}>
              <p><strong>Email:</strong> {selectedClientHistory.email}</p>
              <p><strong>Phone:</strong> {selectedClientHistory.phone}</p>
              {selectedClientHistory.formula_notes && (
                <p><strong>Formula Notes:</strong> {selectedClientHistory.formula_notes}</p>
              )}
            </div>

            {appointmentHistory.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Service</th>
                    <th>Stylist</th>
                    <th>Duration</th>
                    <th>Price</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {appointmentHistory.map(apt => (
                    <tr key={apt.id}>
                      <td>{apt.appointment_date}</td>
                      <td>{apt.appointment_time}</td>
                      <td>{apt.service_name}</td>
                      <td>{apt.stylist_name || '-'}</td>
                      <td>{apt.service_duration} min</td>
                      <td>${apt.service_price}</td>
                      <td>{apt.notes}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="no-results">No appointment history found for this client.</p>
            )}

            <div className="modal-actions">
              <button type="button" onClick={() => { setShowHistory(false); setSelectedClientHistory(null); setAppointmentHistory([]); }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Clients;
